import { render, staticRenderFns } from "./SettingsWebhooksEndpoint.vue?vue&type=template&id=398be4f7"
import script from "./SettingsWebhooksEndpoint.vue?vue&type=script&lang=js"
export * from "./SettingsWebhooksEndpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports